import { Component, Input } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";

@Component({
    selector: "edp-widget-chart-billing",
    templateUrl: "./edp-widget-chart-billing.component.html",
    styleUrls: ["./edp-widget-chart-billing.component.scss"]
})
export class EdpWidgetChartBillingComponent {

    @Input() set balance(balance: any) {
        this.balanceObject = balance;
        this.balanceValue = this.balanceObject.balance;
        if (this.balanceValue > "0") {
            this.balanceValue = this.balanceValue.toString().replace(".", ",");
        }
        if ( this.balanceValue < "0" ) {
            this.showCredit = true;
            this.value = ((this.balanceValue)  + "").split(".")[0];
            this.decimals = ((this.balanceValue) + "").split(".")[1];
        } else {
            this.showCredit = false;
        }
    }

    @Input() set chartId(chartId: string) {
        this.chartName = chartId;
    }

    @Input() set contractSelected(contract: Contract) {
        this.contract = contract;
    }

    public balanceObject: { balance: string; };
    public chartName: string;
    public showCredit: boolean;
    public balanceValue: string;
    public contract: Contract;
    public value: string;
    public decimals: string;

}
